import { baseApi } from "@/shared/api/baseApi";

export interface NotificacaoItem {
  id: number;
  eTipo: number;
  tipoNome: string;
  titulo: string;
  mensagem: string;
  resourceType: string | null;
  resourceId: string | null;
  linkAcao: string | null;
  lida: boolean;
  dataLeitura: string | null;
  dataCadastro: string;
}

export interface NotificacoesListaResponse {
  totalNaoLidas: number;
  itens: NotificacaoItem[];
}

export const notificacaoApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listarNotificacoes: builder.query<NotificacoesListaResponse, number | void>({
      query: (limite) => `/api/notificacao/listar${limite ? `?limite=${limite}` : ""}`,
    }),
    contarNotificacoesNaoLidas: builder.query<{ total: number }, void>({
      query: () => "/api/notificacao/nao-lidas/total",
    }),
    marcarNotificacaoLida: builder.mutation<void, number>({
      query: (id) => ({
        url: `/api/notificacao/${id}/marcar-lida`,
        method: "PATCH",
      }),
    }),
    marcarTodasNotificacoesLidas: builder.mutation<void, void>({
      query: () => ({
        url: "/api/notificacao/marcar-todas-lidas",
        method: "PATCH",
      }),
    }),
  }),
});

export const {
  useListarNotificacoesQuery,
  useContarNotificacoesNaoLidasQuery,
  useMarcarNotificacaoLidaMutation,
  useMarcarTodasNotificacoesLidasMutation,
} = notificacaoApi;
